import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injector } from '@angular/core';
import { NibTravelHttpError } from '@nibtravel/shared/util/models';
import { ENV_VARIABLES } from '@nibtravel/shared/util/constants';

import { ErrorService } from './error.service';
import { LoggerService } from '../logger.service';

export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: Error | HttpErrorResponse | NibTravelHttpError): void {
    // This means the error has been handled elsewhere
    if (error instanceof NibTravelHttpError && error.handled) {
      return;
    }

    const errorService = this.injector.get(ErrorService);
    const logger = this.injector.get(LoggerService);
    const env = this.injector.get(ENV_VARIABLES);

    if (error instanceof HttpErrorResponse) {
      const errorModel = errorService.getErrorModel(error);
      logger.error({
        value: errorModel,
        category: 'HttpError',
        logToConsole: !env.production,
      });
    } else {
      logger.error({
        value: error,
        category: 'Front end error',
        logToConsole: !env.production,
      });
    }
  }
}
